var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
var getOpacityByLevel = function (props) {
    switch (props.level) {
        case 0: {
            return "0";
        }
        case 1: {
            return "0.05";
        }
        case 2: {
            return "0.07";
        }
        case 3: {
            return "0.08";
        }
        case 4: {
            return "0.09";
        }
        case 6: {
            return "0.11";
        }
        case 8: {
            return "0.12";
        }
        case 12: {
            return "0.14";
        }
        case 16: {
            return "0.15";
        }
        case 24: {
            return "0.16";
        }
        default: {
            return "0";
        }
    }
};
export var Overlay = styled.div.attrs({
    className: "Overlay",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: #ffffff; // ! OVERLAY\n  opacity: ", ";\n  transition: opacity 150ms;\n  z-index: ", ";\n  overflow: hidden;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: #ffffff; // ! OVERLAY\n  opacity: ", ";\n  transition: opacity 150ms;\n  z-index: ", ";\n  overflow: hidden;\n  pointer-events: none;\n"])), getOpacityByLevel, function (props) { return props.zIndex || "auto"; });
var templateObject_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3ZlcmxheVN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk92ZXJsYXlTdHlsZXMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUV2QyxJQUFNLGlCQUFpQixHQUFHLFVBQUMsS0FBd0I7SUFDakQsUUFBUSxLQUFLLENBQUMsS0FBSyxFQUFFO1FBQ25CLEtBQUssQ0FBQyxDQUFDLENBQUM7WUFDTixPQUFPLEdBQUcsQ0FBQztTQUNaO1FBQ0QsS0FBSyxDQUFDLENBQUMsQ0FBQztZQUNOLE9BQU8sTUFBTSxDQUFDO1NBQ2Y7UUFDRCxLQUFLLENBQUMsQ0FBQyxDQUFDO1lBQ04sT0FBTyxNQUFNLENBQUM7U0FDZjtRQUNELEtBQUssQ0FBQyxDQUFDLENBQUM7WUFDTixPQUFPLE1BQU0sQ0FBQztTQUNmO1FBQ0QsS0FBSyxDQUFDLENBQUMsQ0FBQztZQUNOLE9BQU8sTUFBTSxDQUFDO1NBQ2Y7UUFDRCxLQUFLLENBQUMsQ0FBQyxDQUFDO1lBQ04sT0FBTyxNQUFNLENBQUM7U0FDZjtRQUNELEtBQUssQ0FBQyxDQUFDLENBQUM7WUFDTixPQUFPLE1BQU0sQ0FBQztTQUNmO1FBQ0QsS0FBSyxFQUFFLENBQUMsQ0FBQztZQUNQLE9BQU8sTUFBTSxDQUFDO1NBQ2Y7UUFDRCxLQUFLLEVBQUUsQ0FBQyxDQUFDO1lBQ1AsT0FBTyxNQUFNLENBQUM7U0FDZjtRQUNELEtBQUssRUFBRSxDQUFDLENBQUM7WUFDUCxPQUFPLE1BQU0sQ0FBQztTQUNmO1FBQ0QsT0FBTyxDQUFDLENBQUM7WUFDUCxPQUFPLEdBQUcsQ0FBQztTQUNaO0tBQ0Y7QUFDSCxDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxPQUFPLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUM7SUFDdEMsU0FBUyxFQUFFLFNBQVM7Q0FDckIsQ0FBQyxxU0FBNEMsNkhBT2pDLEVBQWlCLDhDQUVqQixFQUFpQyxtREFHN0MsS0FMWSxpQkFBaUIsRUFFakIsVUFBQyxLQUFLLElBQUssT0FBQSxLQUFLLENBQUMsTUFBTSxJQUFJLE1BQU0sRUFBdEIsQ0FBc0IsQ0FHN0MsQ0FBQyJ9